import styled from "styled-components";

export const OffersContainerStyled = styled.div`
  padding: 28px 0px 0px 0px;
  max-width: 327px;
  width: 100%;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    max-width: 517px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: 921px;
    padding: 60px 0px 0px 0px;
  }
`;

export const CardGrid = styled.div`
  display: grid;
  margin: 0;
  padding: 0;
  grid-column-gap: ${({ theme }) => theme.customTheme.pxToRem(23)};
  grid-row-gap: ${({ theme }) => theme.customTheme.pxToRem(23)};
  grid-template-columns: repeat(2, 152px);

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    grid-template-columns: repeat(2, 250px);
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    grid-template-columns: repeat(3, 291px);
  }
`;
